import React, {useEffect, useRef} from 'react';
import {withStyles} from "@material-ui/core/styles";
import {Button, ButtonGroup} from "@material-ui/core";
import {connect} from 'react-redux';
import {saveUserViewOpts} from '../../../state/actions/updateDataActions';
import {deepCmp, deepMerge, diffLeft} from "../../../helpers/JsUtils";
import {getUserViewOpts} from "../../../state/actions/getDataActions";
import {SaveIcon, ViewOptionIcon} from "../../../helpers/Icons";

const styles = {
  toolbarMenu: {
    flexWrap:'wrap',
    margin: '1px 0 0 1px',
    '& > button':{
      margin: '-1px 0 0 -1px',
      borderColor: '#c4c4c4',
      flexBasis:'min-content',
      flexGrow:1
    },
    '& > button:not(:last-child)':{
      borderColor: '#c4c4c4'
    }
  },
  toolbarButton: {
    padding: '5.1px 10.2px',
    fontSize: '0.7225em',
    height: '34px',
    backgroundColor: '#ffffff',
    whiteSpace: 'nowrap',
    '& span:first-child > span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
};

function BindViewOptions(props) {
  const { pageKey, parentState, setParentState, parentProps, defaultViewOpts, userViewOpts, setLoaded, classes} = props;
  const mounted = useRef(false);
  const prevMindfileId = useRef(props.mindfile.id);

  const defaultOpts = {
    rowsPerPage: 12,
    orders: [{f: 'mindfile_items.updated_at', d:  false, n: true}],
    viewMode: 'List',
    ...defaultViewOpts
  };

  const getNewPage = (rowsPerPage) => {
    if(!parentProps.filter_count){
      return 1;
    }
    const itemFirst = Math.min(parentProps.filter_count, ((parentState.controller.page - 1) * parentState.controller.rowsPerPage) + 1);
    const maxPage = Math.ceil(parentProps.filter_count / rowsPerPage);
    return Math.max(1, Math.min(Math.floor(itemFirst / rowsPerPage) + 1, maxPage));
  };
  const viewFields = {
    viewMode: (value) => ({tableView:{viewMode: value}}),
    iconSize: (value) => ({tableView:{iconSize: value}}),
    visibleColumns: (value) => Array.isArray(value) ? {} : {tableView:{visibleColumns: value}},
    rowsPerPage: (value) => ({controller:{rowsPerPage: value, page: getNewPage(value)}, loading:true}),
    orders: (value) => ({controller:{orders: value, page: 1}, loading:true}),
    rssNewsOpen: (value) => ({rssNewsOpen: value}),
  }

  const validateOrders = (orders) => {
    if(!Array.isArray(orders) || orders.length < 1 ||
        orders.find(order => (!order || !order.hasOwnProperty('f') || !order.hasOwnProperty('d')))){
      return null
    }
    return orders.map(order => ({f: order.f, d: order.d, n: order.hasOwnProperty('n') ? order.n : true}));
  }

  const validators = {
    viewMode: (value) => {
      switch(value){
        case 'List':
        case 'Icon':
        case "Stream":
          return value;
        default:
          return null;
      }
    },
    iconSize: (value) => {
      switch(value){
        case 'Small':
        case 'Medium':
        case "Large":
          return value;
        default:
          return null;
      }
    },
    visibleColumns: (value) => !Array.isArray(value) ? value : null,
    rowsPerPage: (value) => typeof(value) === "number" && value > 1 && value <= 120 ? value : null,
    orders: validateOrders,
    rssNewsOpen: (value) => typeof(value) === "number" ? value : null,
  }

  const getCurrentViewOpts = () => {
    return {
      viewMode: parentState.tableView.viewMode,
      iconSize: parentState.tableView.iconSize,
      visibleColumns: parentState.tableView.visibleColumns,
      rowsPerPage:parentState.controller.rowsPerPage,
      orders:parentState.controller.orders,
      rssNewsOpen:parentState.rssNewsOpen,
    };
  };

  const setViewOptions = (viewOpts, optMap, callback=() => {}) => {
    let viewState = {viewSet: true};
    viewOpts = diffLeft({...defaultOpts, ...viewOpts}, getCurrentViewOpts());
    for(let key in viewOpts){
      let update = optMap[key];
      let validator = validators[key];
      if(typeof(update) === 'function' && typeof(validator) === 'function'){
        const newVal = validator(viewOpts[key]);
        if(newVal !== null) {
          viewState = deepMerge(update(newVal), viewState);
        }
      }
    }
    const newState = deepMerge(viewState, parentState);
    setParentState(newState, callback) ;
  }

  const validate = (viewOpts) => {
    if(viewOpts === null || typeof(viewOpts) === 'undefined'){
      return null;
    }
    let viewState = {};
    for(let key in viewOpts){
      let validator = validators[key];
      if(typeof(validator) === 'function'){
        const newVal = validator(viewOpts[key]);
        if(newVal !== null) {
          viewState[key] = newVal;
        }
      }
    }
    return viewState;
  };

  const pageViewOpts = userViewOpts && userViewOpts.opts ? validate(userViewOpts.opts[pageKey]) : null;

  if(userViewOpts.mindfile_id !== props.mindfile.id || prevMindfileId.current !== props.mindfile.id){
    mounted.current = false;
  }
  useEffect(() => {
    if(!userViewOpts.loaded || userViewOpts.mindfile_id !== props.mindfile.id){
      return;
    }
    if (!mounted.current) {
      prevMindfileId.current = props.mindfile.id;
      let newPageViewOpts = userViewOpts ? validate(userViewOpts.opts[pageKey]) : null;
      setLoaded(false);
      if(newPageViewOpts) {
        setViewOptions(newPageViewOpts, viewFields, () => {
          mounted.current = true;
          setLoaded(true)
        })
      }else if(userViewOpts.loaded){
        mounted.current = true;
        setLoaded(true)
      }
    }
  },
    // eslint-disable-next-line
  [userViewOpts.mindfile_id, userViewOpts.loaded, props.mindfile.id]
  );

  if(!mounted.current){
    return null;
  }


  const removeKey = (key, opts) => {
    if(opts === null){
      return null;
    }
    // eslint-disable-next-line no-unused-vars
    const {[key]:ignored={}, ...rest} = opts;
    return Object.keys(rest).length > 0 ? rest : null;
  }

  const removeRss = removeKey.bind(this, "rssNewsOpen")
  const modRss = (curView, curDef, curSave) => {
    if(parentState.rssNewsOpen !== defaultOpts.rssNewsOpen &&
      (!pageViewOpts || parentState.rssNewsOpen !== pageViewOpts.rssNewsOpen)){
      props.saveUserViewOpts(pageKey, {...pageViewOpts, rssNewsOpen: parentState.rssNewsOpen});
      return [curView, curDef, {...curSave, rssNewsOpen: parentState.rssNewsOpen}];
    }
    if(!!parentState.rssFeed && !!parentState.rssFeed.items && !!pageViewOpts){
      if(parentState.rssFeed.items[0].skip){
        return [removeRss(curView), removeRss(curDef), removeRss(curSave)];
      }
      const pubTime = new Date(parentState.rssFeed.items[0].pubDate).getTime();
      if(!!pageViewOpts.rssNewsOpen && pageViewOpts.rssNewsOpen < pubTime){
        return [removeRss(curView), removeRss(curDef), removeRss(curSave)];
      }
    }
    return [curView, curDef, curSave];
  };

  const removeIconSize = removeKey.bind(this, "iconSize")
  const modIconSize = (curView, curDef, curSave) => {
    if(curView.viewMode !== "Icon"){
      return [removeIconSize(curView), removeIconSize(curDef), removeIconSize(curSave)];
    }
    return [curView, curDef, curSave];
  }

  let curView = getCurrentViewOpts();
  let curDef = defaultOpts;
  let curSave = pageViewOpts;

  let mods = modRss(curView, curDef, curSave);
  if(!mods) {
    return null;
  }
  mods = modIconSize(curView, curDef, curSave);
  if(!mods) {
    return null;
  }
  [curView, curDef, curSave] = mods;

  const pageDiff = diffLeft(curView, curDef);
  const viewingSaved = deepCmp(curSave, pageDiff);
  const viewingDefault = !pageDiff || Object.keys(pageDiff).length === 0
  const isDefaultSaved = !curSave || Object.keys(curSave).length === 0
  const hideViewSaved = (!viewingDefault && isDefaultSaved) || viewingSaved || (!curSave);
  const hideSaveOpt = viewingSaved || (!curSave && viewingDefault)
  const saveCurrentView = () => {
    props.saveUserViewOpts(pageKey, pageDiff);
  }

  if(hideViewSaved && viewingDefault && hideSaveOpt){
    return null;
  }
  return <ButtonGroup variant="outlined" className={classes.toolbarMenu} style={{flexWrap:'wrap'}}>
    {hideViewSaved ? null :
      <Button variant="outlined"
        id="viewSavedOpts"
        className={classes.toolbarButton}
        onClick={setViewOptions.bind(this, pageViewOpts, viewFields, null)}
        startIcon={<ViewOptionIcon/>}
      >View Saved</Button>}
    {viewingDefault ? null :
      <Button variant="outlined"
        id="viewDefaultOpts"
        className={classes.toolbarButton}
        onClick={setViewOptions.bind(this, defaultOpts, viewFields, null)}
        startIcon={<ViewOptionIcon/>}
      >View Default</Button>}
    {hideSaveOpt ? null :
      <Button variant="outlined"
        id="saveViewOpts"
        className={classes.toolbarButton}
        onClick={saveCurrentView}
        startIcon={<SaveIcon />}
      >Save View</Button>}
  </ButtonGroup>;

}

const mapStateToProps = state => {
  return {
    userViewOpts: state.userViewOpts,
    mindfile:state.mindfile
  };
}

const mapDispatchToProps = {
  saveUserViewOpts,
  getUserViewOpts
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BindViewOptions));
